import { MenuItem, FormControl, Select, Checkbox, IconButton, Typography} from "@mui/material";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ModeOfSignRadioButton from "./ModeOfSignRadioButton";
import { DatePicker } from '@mui/x-date-pickers';
import { DateRange } from "@mui/icons-material";
import { ModeOfSigningKeysForQuotation,QuotationReportType } from "../../_helpers";

export const getPerson1Info = (t, data) => {
  const p1 = data?.person1 || {};
  
  return [
      { title: t('general.name'), value: p1.name || "" },
      { title: t('general.lastName'), value: p1.lastName || "" },
      { title: t('general.namePrefixes'), value:  p1?.middleName?.name || ""},
      { title: t('general.initials'), value: p1.initials || "" },
      { title: t('general.firstName'), value: p1.firstName || "" },
      { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p1?.telephonePrivate || ''},
      { title: t('buyersGuide.buyersInfo.phoneWork'), value: p1.telephoneWork || '' },
      { title: t('buyersGuide.mobile'), value: p1.mobile || ''},
      { title: t('general.emailPrivate'), value: p1.emailPrivate || '' },
      { title: t('buyersGuide.buyersInfo.emailWork'), value: p1.emailWork || '' },
      { title: t('buyersGuide.quotation.loginEmail'), value: p1.loginEmail || "info@huisinfo.nl" }
  ];
};

export const getPerson2Info = (t, data) => {
  const p2 = data?.person2 || {};
  return [
      { title: t('general.name'), value: p2.name || "" },
      { title: t('general.lastName'), value: p2.lastName || "" },
      { title: t('general.namePrefixes'), value: p2?.middleName?.name || ""},
      { title: t('general.initials'), value: p2.initials || "" },
      { title: t('general.firstName'), value: p2.firstName || "" },
      { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p2?.telephonePrivate || '' },
      { title: t('buyersGuide.buyersInfo.phoneWork'), value: p2.telephoneWork || '' },
      { title: t('buyersGuide.mobile'), value: p2.mobile || ''},
      { title: t('general.emailPrivate'), value: p2.emailPrivate || '' },
      { title: t('buyersGuide.buyersInfo.emailWork'), value: p2.emailWork || '' },
      { title: t('buyersGuide.quotation.loginEmail'), value: p2.loginEmail || '' }
  ];
};

export const getOrganizationInfo = (t, data) => {
  const org = data?.org || {};
 
  return [
    { title: t('general.searchName'), value: org.searchName || "" },
    { title: t('general.namePrefixes'), value: org?.middleName?.name || "" },
    { title: t('general.initials'), value: org.initials || "" },
    { title: t('general.name'), value: org.name || "" },
    { title: t('general.telephone'), value: org.telephone || "" },
    { title: t('general.email'), value: org.email || "" },
    { title: t('general.website'), value: org.website || "" },
    { title: t('buyersGuide.quotation.loginEmail'), value: org.loginEmail }

  ];
};


export const getRelationDetails = (t, data) => {
  const org = data?.org || {};
  return [
    { title: t('general.lastName'), value: org.lastName || "" },
    { title: t('general.namePrefixes'), value: org?.middleName?.name || "" },
    { title: t('general.initials'), value: org.initials || "" },
    { title: t('general.firstName'), value: org.relationName || "" },
    { title: t('general.function'), value: org.relationFunctionName || "" },
    { title: t('general.department'), value: org.relationDepartment || "" },
    { title: t('buyersGuide.businessEmail'), value: org.relationEmail || "" },
     { title: t('general.telephone'), value: org.relationTelephone || "" },
    { title: t('buyersGuide.mobile'), value: org.relationMobile || "" },
    { title: t('buyersGuide.quotation.loginEmail'), value: org.loginEmail }
  ];
};


export const getQuotationSetting = (t,quotationDefaults,setQuotationDefaults,isPerson1Checked,isPerson2Checked,setIsPerson1Checked,setIsPerson2Checked,buyersRentersRaw,handleFileUpload,uploadedFile)=>{
    if (!quotationDefaults) {
    return []; 
  }
  const hasPerson2 = !!buyersRentersRaw?.p2?.personId;

    return [
        { title: t('buyersGuide.quotation.number'), value:  <Typography variant="caption">{t('general.autoField')}</Typography> },
        {
            title: t('communication.report'),
            value: (
            <FormControl  sx={{ minWidth: 125, padding: 0}} size="small">
                <Select
                labelId="report-select-label"
                value={quotationDefaults?.reportType ?? ""}
                onChange={(e) =>
              setQuotationDefaults(prev => ({
                ...prev,
                reportType: e.target.value
              }))
            }
          >
           {Object.entries(QuotationReportType).map(([label, value]) => (
                <MenuItem key={value} value={value}>
                  {value === 0 ? t('buyersGuide.quotation.report.quotation') : t('buyersGuide.quotation.report.quotationPerStatus')}
                </MenuItem>
    ))}
                </Select>
            </FormControl>
            ),
        },
        { title: t('buyersGuide.quotation.closingDate'), value:(
        <DatePicker
                variant="standard"
                format="dd-MM-yyyy"
                id="birth-date-picker"
                minDate={new Date()}
                onChange={(newValue) =>
              setQuotationDefaults(prev => ({
              ...prev,
              closingDate: new Date(newValue).toJSON()
            }))
          }
                slotProps={{
                  openPickerButton: { edge: "end", size: "small" },
                  textField: {
                    variant: "outlined",
                    size: "small",
                    InputLabelProps: {
                      shrink: true,
                    }
                  },
                }}
                enableAccessibleFieldDOMStructure={false}
                slots={{
                  openPickerButton: IconButton,
                  openPickerIcon: DateRange,
                }}
             value={quotationDefaults?.closingDate ? new Date(quotationDefaults?.closingDate) : quotationDefaults?.closingDate}

        />
      ) },
        { title: t('contract.details.signing'),  value: (
          <FormControl sx={{ minWidth: 125, padding: 0 }} size="small">
            <Select
              value={quotationDefaults?.modeOfSigning ?? ModeOfSigningKeysForQuotation.DigitalSign}
              onChange={(e) =>
                setQuotationDefaults(prev => ({
                  ...(prev ?? {}),
                  modeOfSigning: e.target.value,
                }))
              }
            >
              {Object.values(ModeOfSigningKeysForQuotation).map((value) => (
                <MenuItem key={value} value={value}>
                  {t(`buyersGuide.options.generate.signatureType.${value}`)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
      ), },
            ...(hasPerson2
      ? [
        {
            title: `${t('general.person')} 1`,
            value: (
              <Checkbox
                sx={{ padding: 0 }}
                checked={isPerson1Checked}
                onChange={(e) => setIsPerson1Checked(e.target.checked)}
              />
            ),
          },
          {
            title: `${t('general.person')} 2`,
            value: (
              <Checkbox
                sx={{ padding: 0 }}
                checked={isPerson2Checked}
                onChange={(e) => setIsPerson2Checked(e.target.checked)}
              />
            ),
          },
        ]
      : []),


        { title:t('buyersGuide.quotation.amountsInclVAT'), value: 
            <div>
                <Checkbox  
                 checked={ quotationDefaults?.isPriceIncludingVAT ?? ''}
                 sx={{ padding: 0 }}
              onChange={(e) =>
                setQuotationDefaults(prev => ({
                  ...prev,
                  isPriceIncludingVAT: e.target.checked,
                }))
              }
                 />
            </div> 
        },
        { title: t('buyersGuide.quotation.drawingSelection'),  value: (
    <>
      <input
        type="file"
        accept="image/*,application/pdf"
        style={{ display: "none" }}
        id="drawing-file-upload"
        onChange={handleFileUpload}
      />

      <label htmlFor="drawing-file-upload">
        <IconButton component="span">
          <CloudUploadOutlinedIcon />
        </IconButton>
      </label>

      {uploadedFile && (
        <Typography variant="caption">
          {uploadedFile.name}
        </Typography>
      )}
    </>
  ) },
    ];
}

export const getModeOfSigningDetails = (t,selectedMode, handleChange) => [
    {
        title: t('general.mobileNumber'),
        value: <ModeOfSignRadioButton option="mobile" selected={selectedMode} onChange={handleChange} />
    }
];


export const getBuyersRentersInformation = (t, data) => {
  if (!data) return [];

  const isBuyer = data.type === 0;

  if (isBuyer) {
    const result = [
      {
        title: `${t('general.person')} 1`,
        details: getPerson1Info(t, { person1: data.p1 }),
      },
    ];

    if (data.p2) {
      result.push({
        title: `${t('general.person')} 2`,
        details: getPerson2Info(t, { person2: data.p2 }),
      });
    }

    return result;
  }

  return [
    {
      title: t('general.organisation'),
      tabIndex: 0,
      details: getOrganizationInfo(t, { org: data.org }),
    },
    {
      title: t('workOrders.relation'),
      details: getRelationDetails(t, { org: data.org }),
      tabIndex: 0,
    },
  ];
};


export const getDynamicSettingInfo = (
  t,
  quotationDefaults,
  setQuotationDefaults,
  isPerson1Checked,
  isPerson2Checked,
  setIsPerson1Checked,
  setIsPerson2Checked,
  selectedMode,
  handleChange,
  buyersRentersRaw,
  handleFileUpload,
  uploadedFile

) =>[
    {
        title: t('buyersGuide.quotation.setting'),
        details: getQuotationSetting(t,quotationDefaults,setQuotationDefaults,isPerson1Checked,isPerson2Checked,setIsPerson1Checked,setIsPerson2Checked,buyersRentersRaw,handleFileUpload,uploadedFile),
    },
    {
        title: t('buyersGuide.quotation.modeOfSignConformation'),
        details: getModeOfSigningDetails(t,selectedMode, handleChange,),
    },
];